<template>
  <div>
    <ServerError v-if="ServerError" />
    <!-- <SuperAdmin v-if="superAd" /> -->
    <!-- <Admins v-if="Admins" /> -->
    <div class="app flex-row align-items-center">
      <div
        id="loadingmessage"
        style="
          text-align: center;
          margin: 0px;
          padding: 0px;
          position: fixed;
          right: 0px;
          top: 0px;
          width: 100%;
          height: 100%;
          background-color: white;
          z-index: 30001;
          opacity: 0.8;
        "
        v-if="appLoading"
      >
        <p style="position: absolute; color: White; top: 40%; left: 50%">
          <img src="../../assets/loader.gif" />
        </p>
      </div>
      <div class="container">
        <b-row class="justify-content-center">
          <b-col md="8" v-if="logiin">
            <b-card-group>
              <b-card no-body class="p-4">
                <b-card-body>
                  <form @submit.prevent="onSubmit">
                    <h1>Login</h1>
                    <p class="text-muted">Sign In to your account</p>
                    <p v-if="msg" style="color: red">{{ msg }}</p>
                    <b-input-group class="mb-3">
                      <b-input-group-prepend>
                        <b-input-group-text>
                          <i class="icon-user"></i>
                        </b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input
                        type="text"
                        class="form-control"
                        placeholder="Username"
                        autocomplete="username email"
                        v-model="login.username"
                        required
                      />
                    </b-input-group>
                    <b-input-group class="mb-4">
                      <b-input-group-prepend>
                        <b-input-group-text>
                          <i class="icon-lock"></i>
                        </b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input
                        type="password"
                        class="form-control"
                        placeholder="Password"
                        autocomplete="current-password"
                        v-model="login.password"
                        required
                      />
                    </b-input-group>
                    <b-row>
                      <b-col cols="6">
                        <b-button
                          type="submit"
                          block
                          style="color: white; font-weight: 500;background-color:#006837"
                        >
                          Login
                        </b-button>
                      </b-col>
                      <b-col cols="6" class="text-right">
                        <b-button
                          variant="link"
                          @click="logiin = false"
                          class="px-0"
                          style="color: grey; font-weight: 500"
                          >Forgot password?</b-button
                        >
                      </b-col>
                    </b-row>
                  </form>
                </b-card-body>
              </b-card>
              <b-card
                no-body
                class="text-white  py-5 d-md-down-none"
                style="width: 44%"
              >
                <b-card-body class="text-center">
                  <div>
                    <img
                      src="../../assets/logo.png"
                      height="100px"
                      width="auto"
                    />
                    <h2 style="color: grey;">Save Trees Admin Panel</h2>

                    <!-- <b-button variant="primary" class="active mt-3">Register Now!</b-button> -->
                  </div>
                </b-card-body>
              </b-card>
            </b-card-group>
          </b-col>
          <b-col md="8" v-else>
            <b-card-group>
              <b-card
                no-body
                class="text-white py-5 d-md-down-none"
                style="width: 44%"
              >
                <b-card-body class="text-center">
                  <div>
                    <img
                      src="../../assets/logo.png"
                      height="100px"
                      width="auto"
                    />
                    <h2 style="color: grey;">Save Trees Admin Panel</h2>
                    <!-- <p>
                      The admin panel to monitor the day to day reports and
                      other services with exciting features.
                    </p> -->
                    <!-- <b-button variant="primary" class="active mt-3">Register Now!</b-button> -->
                  </div>
                </b-card-body>
              </b-card>
              <b-card no-body class="p-4">
                <b-card-body>
                  <h1>Forgot Password</h1>
                </b-card-body>
                <b-card-body v-if="initial">
                  <b-form @submit.prevent="onChange">
                    <p class="text-muted">Enter your registered Email.</p>
                    <p v-if="err" style="color: red">{{ err }}</p>
                    <b-input-group class="mb-3">
                      <b-input-group-prepend>
                        <b-input-group-text>
                          <i class="icon-cursor"></i>
                        </b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input
                        type="text"
                        class="form-control"
                        placeholder="Email"
                        autocomplete="username email"
                        v-model="email"
                        required
                      />
                    </b-input-group>

                    <b-row>
                      <b-col cols="6">
                        <b-button
                          variant="link"
                          @click="logiin = true"
                          class="px-0"
                          style="color: grey; font-weight: 500"
                          >Cancel</b-button
                        >
                      </b-col>
                      <b-col cols="6" class="text-right">
                        <b-button
                          type="submit"
                          block
                          style="color: white; font-weight: 500;background-color:#006837"
                          @click.prevent="onChange"
                        >
                          Submit
                        </b-button>
                      </b-col>
                    </b-row>
                  </b-form>
                </b-card-body>

                <b-card-body v-if="change">
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-pencil"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      type="text"
                      class="form-control"
                      placeholder="Enter Code"
                      autocomplete="username email"
                      v-model="code"
                      required
                    />
                  </b-input-group>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-lock"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      type="text"
                      class="form-control"
                      placeholder="New Password"
                      autocomplete="newpassword"
                      v-model="code"
                      required
                    />
                  </b-input-group>

                  <b-row>
                    <b-col cols="6">
                      <b-button
                        variant="link"
                        @click="logiin = true"
                        class="px-0"
                        style="color: grey; font-weight: 500"
                        >Cancel</b-button
                      >
                    </b-col>
                    <b-col cols="6" class="text-right">
                      <b-button
                        type="submit"
                       block
                        style="color: white; font-weight: 500;background-color:#006837"
                        @click="newlogin"
                      >
                        Submit
                      </b-button>
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-card-group>
          </b-col>
        </b-row>
      </div>
    </div>
    <div class="col-md-12">
      <!--footer-->
      <a target="_blank" href="https://www.ndns.in/save-trees-app/">Save Trees</a>
      <span class="ml-1">&copy; {{ new Date().getFullYear() }}</span>
      <b style="float: right">
        <span class="mr-1">Powered by</span>
        <a href="http://leopardtechlabs.com" target="_blank"
          >Leopard Tech Labs Pvt. Ltd</a
        >
      </b>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import store from "../../store";
import SuperAdmin from "./../adminRegistration/superAdminRegistration";
export default {
  name: "login",
  components: {
    SuperAdmin,
  },
  data() {
    return {
      login: {},
      logiin: true,
      msg: null,
      err: null,
      email: null,
      appLoading: false,
      ServerError: false,
      superAd: false,
      Admins: false,
      code: null,
      newpassword: null,
      confirmpassword: null,
      change: false,
      initial: true,
    };
  },
  methods: {
    onSubmit() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/user/adminlogin",
        data: this.login,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.msg = null;
            store.commit("loginUser");
            localStorage.setItem("token", response.data.data.token);
            localStorage.setItem("role", response.data.data.type);
            localStorage.setItem("isroot", response.data.data.isroot);
            localStorage.setItem("userName", response.data.data.username);
            // console.log(response.data.data.type)
            // console.log(response.data.data.isroot)
            if (
              response.data.data.type == "Admin" &&
              response.data.data.isnew
            ) {
              // this.superAd = true;
              this.$router.push("/superAdminRegister");
            } else if (
              (response.data.data.type == "CountryAdmin" ||
                response.data.data.type == "StateAdmin" ||
                response.data.data.type == "CityAdmin") &&
              response.data.data.isnew
            ) {
              this.$router.push("/adminRegister");
            } else {
              this.$router.push("/");
            }
            // this.getProfile()
          } else {
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.ServerError = false;
        });
    },
    onChange() {
      this.appLoading = false;
      axios({
        method: "POST",
        url: "/forgot/password/handshake",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          email: this.email,
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.appLoading = false;
            this.initial = false;
            this.change = true;
          } else this.err = "User not found!";
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
    newlogin() {
      this.appLoading = false;
      axios({
        method: "GET",
        url: "/forgot/password/change",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          otp: this.code,
          password: this.newpassword,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.logiin = true;
          this.initial = true;
          this.change = false;
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
    getProfile() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/profile",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
  },
};
</script>
